import { useContext } from 'react';
import AuthContext from '@domain/auth/auth.context';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('No AuthContext available, make sure the Provider is in place');
  }
  return context;
};
